const cols = [
  {
    title: "Initiative",
    links: [
      { label: "Food Security Gap", href: "/#gap" },
      { label: "Our System", href: "/#system" },
      { label: "Orchards", href: "/orchards" },
      { label: "Impact", href: "/#impact" },
      { label: "Policy Briefing", href: "/policy-briefing" },
    ],
  },
  {
    title: "Connect",
    links: [
      { label: "Contact", href: "/#contact" },
      { label: "Partners", href: "/#get-involved" },
      { label: "Press", href: "mailto:press@growingcountry.org" },
      { label: "Careers", href: "mailto:careers@growingcountry.org" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-charcoal text-sand pt-20 pb-10 overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay opacity-50" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 pb-16 border-b border-sand/15">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="inline-block w-2 h-2 bg-rust" aria-hidden />
              <span className="font-serif text-2xl md:text-3xl tracking-tight">
                Growing<span className="italic font-light"> Country</span>
              </span>
            </div>
            <p className="mt-6 max-w-md text-sand/70 leading-relaxed">
              Growing Country is not simply about growing food. It is about
              rebuilding local capability, strengthening community resilience,
              and restoring relationships between people, food and Country.
            </p>
            <div className="mt-8 text-xs uppercase tracking-[0.28em] text-ochre/80">
              Building Australia's Indigenous Food Future
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <div className="text-[11px] uppercase tracking-[0.28em] text-sand/50 mb-5">
                {col.title}
              </div>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-sm text-sand/85 hover:text-ochre transition-colors"
                      data-testid={`footer-link-${l.label.toLowerCase()}`}
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Acknowledgement */}
          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.28em] text-sand/50 mb-5">
              Acknowledgement
            </div>
            <p className="text-sm text-sand/75 leading-relaxed italic font-serif">
              We acknowledge the Traditional Custodians of the lands and waters
              on which we work. Sovereignty was never ceded.
            </p>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-sand/45">
          <div>© {new Date().getFullYear()} Growing Country</div>
          <div className="flex items-center gap-3">
            <span className="inline-block w-6 h-px bg-sand/40" />
            <span>www.growingcountry.org</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
